export var RecentContainerType = /*#__PURE__*/function (RecentContainerType) {
  RecentContainerType["JIRA_PROJECT"] = "jira-project";
  RecentContainerType["CONFLUENCE_SPACE"] = "confluence-space";
  return RecentContainerType;
}({});
export var CollaborationGraphRecentContainerType = /*#__PURE__*/function (CollaborationGraphRecentContainerType) {
  CollaborationGraphRecentContainerType["JIRA_PROJECT"] = "jiraProject";
  CollaborationGraphRecentContainerType["CONFLUENCE_SPACE"] = "confluenceSpace";
  return CollaborationGraphRecentContainerType;
}({});
export var Permissions = /*#__PURE__*/function (Permissions) {
  Permissions["MANAGE"] = "manage";
  Permissions["CAN_INVITE_USERS"] = "invite-users";
  return Permissions;
}({});
export var Product = /*#__PURE__*/function (Product) {
  Product["BITBUCKET"] = "bitbucket";
  Product["CONFLUENCE"] = "confluence";
  Product["HOME"] = "home";
  Product["JIRA"] = "jira";
  Product["SITE_ADMIN"] = "site-admin";
  Product["TRELLO"] = "trello";
  Product["START"] = "start";
  return Product;
}({});
export var Feature = /*#__PURE__*/function (Feature) {
  Feature["enableRecentContainers"] = "enableRecentContainers";
  Feature["xflow"] = "xflow";
  Feature["isProductStoreInTrelloJSWFirstEnabled"] = "isProductStoreInTrelloJSWFirstEnabled";
  Feature["isProductStoreInTrelloConfluenceFirstEnabled"] = "isProductStoreInTrelloConfluenceFirstEnabled";
  Feature["isSlackDiscoveryEnabled"] = "isSlackDiscoveryEnabled";
  Feature["isUFOEnabled"] = "isUFOEnabled";
  Feature["isHighlightJwmInSwitcherExtendedAudienceEnabled"] = "isHighlightJwmInSwitcherExtendedAudienceEnabled";
  return Feature;
}({});

// Coincides with the product types in the Available Products Service

export var AnalyticsItemType = /*#__PURE__*/function (AnalyticsItemType) {
  AnalyticsItemType["PRODUCT"] = "product";
  AnalyticsItemType["ADMIN"] = "admin";
  AnalyticsItemType["TRY"] = "try";
  AnalyticsItemType["JOIN"] = "join";
  AnalyticsItemType["CUSTOM_LINK"] = "customLink";
  AnalyticsItemType["DISCOVER_FIXED_LINKS"] = "discover-fixed-links";
  AnalyticsItemType["RECENT"] = "recent";
  AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
  return AnalyticsItemType;
}({});
export var ProductKey = /*#__PURE__*/function (ProductKey) {
  ProductKey["CONFLUENCE"] = "confluence.ondemand";
  ProductKey["JIRA_CORE"] = "jira-core.ondemand";
  ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
  ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
  ProductKey["BITBUCKET"] = "bitbucket";
  ProductKey["OPSGENIE"] = "opsgenie";
  ProductKey["STATUSPAGE"] = "statuspage";
  ProductKey["TRELLO"] = "trello";
  ProductKey["COMPASS"] = "compass";
  ProductKey["TEAM_CENTRAL"] = "townsquare";
  return ProductKey;
}({});

// A map of feature flags used by the XFlow recommendations engine.

export var DiscoverLinkItemKeys = /*#__PURE__*/function (DiscoverLinkItemKeys) {
  DiscoverLinkItemKeys["DISCOVER_MORE"] = "discover-more";
  DiscoverLinkItemKeys["SLACK_INTEGRATION"] = "slack-integration";
  return DiscoverLinkItemKeys;
}({});

//